/* eslint-disable */
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
// import router from "./index.js";
import PrimeVue from "primevue/config";
import "primevue/resources/themes/lara-light-blue/theme.css"; // PrimeVue theme
import "primevue/resources/primevue.min.css"; // PrimeVue base styles
import "primeicons/primeicons.css"; // PrimeIcons
import "./assets/global.css"; // Import global DataTable styles
import ConfirmDialog from 'primevue/confirmdialog';
import ConfirmationService from 'primevue/confirmationservice';
import ToastService from 'primevue/toastservice';
import fixInputNumber from './directives/fixInputNumber';

const app = createApp(App);
app.use(router);
app.use(PrimeVue);

// 🧠 Add this:
app.use(ConfirmationService);

// 🧠 Register globally (optional if used in many components)
app.component('ConfirmDialog', ConfirmDialog);
app.use(ToastService);
app.directive('fix-input-number', fixInputNumber);
app.mount("#app");

